import { render, staticRenderFns } from "./EditTaxonomyFamily.vue?vue&type=template&id=b8236e6c&"
import script from "./EditTaxonomyFamily.vue?vue&type=script&lang=js&"
export * from "./EditTaxonomyFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports